$(function () {
	const moment = require("moment-timezone");
	const axios = require("axios");
	const timeZoneName = moment.tz.guess();
	const language = $("html")[0].lang;
	const myProject = require("./_data/myProject");
	const envSettings = myProject[myProject.environment];

	const maxFiles = 5;
	const continueBtn = $("#transferContinueBtn");
	const sendBtn = $("#transferSendBtn");

	let attachmentIdArray = [];
	let files;

	// defaults
	$.ajaxSetup({
		headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
		contentType: "application/json; charset=utf-8",
		dataType: "json",
	});

	const Uris = {
		jsonAttachmentsAdd: envSettings.server + "/json/attachments/add",
		jsonAttachmentUpdate: envSettings.server + "/json/attachments/update",
	};

	updateForm();

	$("transferForm").submit(false);
	$("#transferPhoneNumber").on("input", function (e) {
		updateTransfer();
	});
	$("#transferEmail").on("input", function (e) {
		updateTransfer();
	});
	$("#transferLanguages").on("change", function (e) {
		updateTransfer();
	});
	$("#transferFirstName").on("input", function (e) {
		updateTransfer();
	});
	$("#transferLastName").on("input", function (e) {
		updateTransfer();
	});
	$("#transferOrganizationName").on("input", function (e) {
		updateTransfer();
	});
	$("#transferNotes").on("input", function (e) {
		updateTransfer();
	});

	continueBtn.on("click", function (event) {
		if ($("#transferForm")[0].checkValidity()) {
			event.preventDefault();
			setBtnDisabled(continueBtn);

			files = $("#transferFile")[0].files;
			let fileCount = files.length;

			if (fileCount <= maxFiles) {
				nextFile(fileCount);
			} else {
				alert("Too many files, Max amount is: " + maxFiles);
				setBtnActive(continueBtn);
			}
		}
	});

	sendBtn.on("click", function (event) {
		if ($("#transferForm")[0].checkValidity()) {
			event.preventDefault();
			setBtnDisabled(sendBtn);

			let transfer = JSON.parse(sessionStorage.transfer);
			console.log(transfer);
			let data = {
				customerPhoneNumber: transfer.phoneNumber,
				customerEmail: transfer.email,
				customerLanguages: transfer.languages,
				customerFirstName: transfer.firstName,
				customerLastName: transfer.lastName,
				customerOrganizationName: transfer.organizationName,
				customerNotes: transfer.customerNotes,
				customerAttachmentIds: transfer.attachmentIds,
			};
			console.log(data);

			//backend puuttuu

			setBtnActive(sendBtn);
		}
	});

	function nextFile(fileCount) {
		console.log("nextFile called with " + fileCount + " files left");
		if (fileCount > 0) {
			//const siteKey = "6LdSfKYUAAAAALn4EJIUF6xju2sayl10bBbNSbwA"; //youpret.com
			const siteKey = "6LcEGm4bAAAAAM6t63kP0D7C0lowDj1vr5eOyk8n"; //localhost
			grecaptcha.ready(function () {
				grecaptcha.execute(siteKey, { action: "submit" }).then(function (token) {
					let file = files[fileCount - 1]; //takes the last file
					let data = {
						fileName: file.name,
						contentType: file.type,
						size: file.size,
						publicAccess: false,
						recaptchaToken: token,
					};
					$.ajax({
						url: Uris.jsonAttachmentsAdd,
						method: "POST",
						data: JSON.stringify(data),
					})
						.done(function (data) {
							console.log("File upload started");
							console.log(data);

							let location = data.location;
							let attachmentId = data.attachmentId;

							axios.put(location, file)
								.then(function (data) {
									console.log("File uploading");
									console.log(data);

									data = {
										id: attachmentId,
										status: "COMPLETE",
									};

									$.ajax({
										url: Uris.jsonAttachmentUpdate,
										method: "PUT",
										data: JSON.stringify(data),
									})
										.done(function (data) {
											console.log("File uploaded successfully");
											console.log(data);
											attachmentIdArray.push(attachmentId);
											nextFile(fileCount - 1);
										})
										.fail(function (err) {
											console.log("error 3");
											console.log(err);
											setBtnActive(continueBtn);
										});
								})
								.catch(function (err) {
									console.log("error 2");
									console.log(err);
									setBtnActive(continueBtn);
								});
						})
						.fail(function (err) {
							console.log("error 1");
							console.log(err);
							setBtnActive(continueBtn);
						});
				});
			});
		} else {
			console.log("All files done");
			updateTransfer();
			setBtnActive(continueBtn);
			//window.location.href = $("#transferOrderUri").val();
		}
	}

	function updateForm() {
		console.log("updateForm called " + window.location);

		if (sessionStorage.transfer != null) {
			let transfer = JSON.parse(sessionStorage.transfer);

			if (transfer.phoneNumber) $("#transferPhoneNumber").val(transfer.phoneNumber);
			if (transfer.email) $("#transferEmail").val(transfer.email);
			if (transfer.languages) $("#transferLanguages").val(transfer.languages);
			if (transfer.firstName) $("#transferFirstName").val(transfer.firstName);
			if (transfer.lastName) $("#transferLastName").val(transfer.lastName);
			if (transfer.organizationName) $("#transferOrganizationName").val(transfer.organizationName);
			if (transfer.customerNotes) $("#transferNotes").val(transfer.customerNotes);
		} else {
			console.log("transfer in session storage is null. No update needed. Uses defaults.");
		}
	}

	function parseTransferOrCreateNew() {
		let transfer = {};
		if (sessionStorage.transfer == null) {
			console.log("init sessionstorage object transfer");
			transfer.phoneNumber = "";
			transfer.email = "";
			transfer.languages = "";
			transfer.firstName = "";
			transfer.lastName = "";
			transfer.organizationName = "";
			transfer.customerNotes = "";
			transfer.attachmentIds = "";

			sessionStorage.transfer = JSON.stringify(transfer);
		} else {
			transfer = JSON.parse(sessionStorage.transfer);
		}
		return transfer;
	}

	function updateTransfer() {
		let transfer = parseTransferOrCreateNew();

		let phoneNumber = $("#transferPhoneNumber").val();
		let email = $("#transferEmail").val();
		let languages = $("#transferLanguages").val();
		let firstName = $("#transferFirstName").val();
		let lastName = $("#transferLastName").val();
		let organizationName = $("#transferOrganizationName").val();
		let customerNotes = $("#transferNotes").val();
		let attachmentIds = attachmentIdArray;

		if (phoneNumber != undefined) transfer.phoneNumber = phoneNumber;
		if (email != undefined) transfer.email = email;
		if (languages != undefined) transfer.languages = languages;
		if (firstName != undefined) transfer.firstName = firstName;
		if (lastName != undefined) transfer.lastName = lastName;
		if (organizationName != undefined) transfer.organizationName = organizationName;
		if (customerNotes != undefined) transfer.customerNotes = customerNotes;
		if (attachmentIds != undefined) transfer.attachmentIds = attachmentIds;

		sessionStorage.transfer = JSON.stringify(transfer);
	}

	function setBtnDisabled(button) {
		button.prop("disabled", true);
		button.html('<span class="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span> Lataa...');
	}

	function setBtnActive(button) {
		button.prop("disabled", false);
		button.html("Jatka");
		if (button == sendBtn) button.html("Lähetä tilaus");
	}
});
